import { useState, useEffect } from 'react';
import useBuildVariantProps from '../../../modules/theme/useBuildVariantProps';
import { CheckboxItemProps } from './CheckboxItem.types';

const usePresenter = (props: CheckboxItemProps) => {
  const {
    checked,
    defaultChecked,
    onValueChange,
    disabled = false,
    invalid = false,
    required = false,
    labelAlignment = 'Left',
    children,
    showRightButton = false,
    onRightButtonClick,
    rightButtonIcon,
    value,
    id,
    ...otherInputProps
  } = props;

  const [isChecked, setIsChecked] = useState(checked ?? defaultChecked ?? false);

  useEffect(() => {
    setIsChecked(!!(checked ?? value));
  }, [checked, value]);

  const handleChange = (value: boolean) => {
    setIsChecked(!!value);
    onValueChange?.(value);
  };

  const variantProps = useBuildVariantProps(
    'checkbox-item',
    {
      styles: isChecked ? 'selected' : 'unselected',
    },
    {
      disabled,
      invalid,
    },
  );

  return {
    variantProps,
    handleChange,
    isChecked,
    disabled,
    required,
    otherInputProps,
    defaultChecked,
    invalid,
    labelAlignment,
    value,
    showRightButton,
    onRightButtonClick,
    rightButtonIcon,
    id,
  };
};

export default usePresenter;